<template>
    <span>
      <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col md="10">
                    <h3>{{ this.$route.name }}</h3>
                 </b-col>
                 <b-col md="2">
                    <b-button v-if="can('questionario.store')" @click="navigate('/formulario/cadastrar')" block variant="primary">
                         <i class="fa fa-plus"></i>
                       <span>Novo Formulário</span>
                    </b-button>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <b-row>
                <b-col sm="12">
                    <b-form-group label="Título do Formulário:">
                        <b-form-input type="text" id="name" v-model="filtros.filter" placeholder="Título"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="4">
                    <b-form-group label="Nº do Formulário:">
                        <b-form-input type="number" id="numCadastro" v-model="filtros.numCadastro"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="4">
                    <b-form-group>
                        <b-form-group label="Situação:">
                            <b-form-select v-model="filtros.situacao" id="checkbox-group-2" :options="situacoes"></b-form-select>
                        </b-form-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                <b-button @click="resetForm()" block>
                    <span>Limpar Filtros</span>
                </b-button>
              </b-col>
            </b-row>
        </b-card-body>
        <b-row>
            <b-col sm="12">
                <b-container fluid>
                       <span>
                          <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                          <thead>
                            <tr>
                              <th scope="col">Nº do Formulário</th>
                              <th scope="col">Título do Formulário</th>
                              <th scope="col">Situação</th>
                              <th scope="col">Enviar E-mail</th>
                              <th scope="col">Configurar CPF</th>
                              <th scope="col">Configurar CNPJ</th>
                              <th scope="col">Ações</th>
                            </tr>
                          </thead>

                          <tbody v-if="questionarios.data !== undefined">
                            <tr class="action" v-for="questionario in questionarios.data" :key="questionario.id">

                              <td>{{questionario.id}}</td>
                              <td style="width: 60%">{{questionario.titulo}}</td>
                              <td style="width: 10%; text-align: center">
                                <span v-if="questionario.status === 'AT'" class="badge badge-success">Ativo</span>
                                <span v-if="questionario.status === 'IN'" class="badge badge-secondary">Inativo</span>
                                <span v-if="questionario.status === 'PU'" class="badge badge-primary">Publicado</span>
                                <span v-if="questionario.status === 'SU'" class="badge badge-warning">Publicação Suspensa</span>
                              </td>
                              <td style="text-align: center">
                                  <span v-if="questionario.envia_email">
                                     <a tabindex="3" class="btn btn-secondary action" title="Desativar" @click="desativarEmail(questionario.id)">
                                      <i class="fa fa-toggle-on"></i>
                                     </a>
                                  </span>
                                  <span v-if="!questionario.envia_email">
                                     <a tabindex="4" class="btn btn-secondary action" title="Ativar" @click="abrirModalEmail(questionario.id)">
                                      <i class="fa fa-toggle-off"></i>
                                     </a>
                                  </span>
                              </td>
                                <td style="text-align: center">
                                  <span v-if="questionario.configura_cpf">
                                     <a tabindex="3" class="btn btn-secondary action" title="Desativar" @click="desativarConfigCpf(questionario.id)">
                                      <i class="fa fa-toggle-on"></i>
                                     </a>
                                  </span>
                                  <span v-if="!questionario.configura_cpf">
                                     <a tabindex="4" class="btn btn-secondary action" title="Ativar" @click="abrirModalConfigCpf(questionario.id)">
                                      <i class="fa fa-toggle-off"></i>
                                     </a>
                                  </span>
                              </td>
                                <td style="text-align: center">
                                  <span v-if="questionario.configura_cnpj">
                                     <a tabindex="3" class="btn btn-secondary action" title="Desativar" @click="desativarConfigCnpj(questionario.id)">
                                      <i class="fa fa-toggle-on"></i>
                                     </a>
                                  </span>
                                  <span v-if="!questionario.configura_cnpj">
                                     <a tabindex="4" class="btn btn-secondary action" title="Ativar" @click="abrirModalConfigCnpj(questionario.id)">
                                      <i class="fa fa-toggle-off"></i>
                                     </a>
                                  </span>
                              </td>
                              <td style="width: 5%">
                                <b-dropdown id="dropdown-1" class="m-md-2" no-flip>
                                  <template v-slot:button-content>
                                    <i class="fa fa-gear"></i>
                                  </template>

                                  <b-dropdown-item
                                    v-if="can('questionario.update')
                                    && questionario.validacao === null"
                                    @click="editarQuestionario(questionario.id)"
                                  >Editar Formulário
                                  </b-dropdown-item>

                                  <b-dropdown-item
                                    v-if="can('questionario.destroy')
                                    && questionario.status != 'AT'
                                    && questionario.status != 'PU'
                                    && questionario.status != 'SU'
                                    && questionario.validacao === null"
                                    @click="modal(questionario.id, 'Excluir')"
                                  >Excluir Formulário
                                  </b-dropdown-item>

                                  <b-dropdown-item
                                    v-if="can('questionario.show')"
                                    @click="visualizarQuestionario(questionario.id)"
                                  >Visualizar Formulário
                                  </b-dropdown-item>

                                  <b-dropdown-item
                                    v-if="can('questionario.showStructure')"
                                    @click="visualizarEstruturaQuestionario(questionario.id)"
                                  >Visualizar Estrutura
                                  </b-dropdown-item>

                                  <b-dropdown-item
                                    v-if="can('questionario.activate')
                                    && questionario.status === 'IN'
                                    && questionario.status != 'PU'
                                    && questionario.status != 'SU'"
                                    @click="modal(questionario.id, 'Ativar')"
                                  >Ativar Formulário
                                  </b-dropdown-item>

                                  <b-dropdown-item
                                    v-if="can('questionario.deactivate')
                                    && questionario.status === 'AT'
                                    && questionario.status != 'PU'"
                                    @click="modal(questionario.id, 'Desativar')"
                                  >Desativar Formulário
                                  </b-dropdown-item>

                                  <b-dropdown-item
                                    v-if="can('questionario.store')"
                                    @click="duplicarQuestionario(questionario.id)"
                                  >Duplicar Formulário
                                  </b-dropdown-item>

                                  <b-dropdown-item
                                    v-if="can('questionario.publish')
                                      && questionario.status != 'PU'
                                      && questionario.status != 'IN'"
                                    @click="publicarQuestionario(questionario.id)"
                                  >Publicar Formulário
                                  </b-dropdown-item>

                                  <b-dropdown-item
                                    v-if="can('questionario.suspend')
                                      && questionario.status === 'PU'"
                                    @click="suspenderPublicacao(questionario.id)"
                                  >Suspender Formulário
                                  </b-dropdown-item>

                                  <b-dropdown-item
                                    v-if="can('questionario.showAnswer')
                                      && questionario.validacao != null"
                                    @click="visualizarRespostas(questionario.id)"
                                  >Visualizar Respostas
                                  </b-dropdown-item>

                                  <b-dropdown-item
                                    v-if="can('questionario.foward')
                                      && questionario.status === 'PU'"
                                    @click="encaminharQuestionario(questionario.id)"
                                  >Encaminhar Formulário
                                  </b-dropdown-item>
                                </b-dropdown>

                              </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                           <tr class="action">
                             <td colspan="9">Nenhum registro de formulários...</td>
                           </tr>
                          </tbody>
                         </table>
                          <pagination v-show="questionarios.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource"></pagination>
                       </span>
                </b-container>
            </b-col>
        </b-row>
      </b-card>
      <b-modal :title="titulo_descricao" size="lg" :ok-title="titulo_botao" cancel-title="Cancelar" v-model="modalControl" @ok="modalConfirma()">
         <b-card-body>
             <b-form>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Nº do Formulário:">
                  <b-input-group class="mb-6">
                    <b-form-input id="id"
                                  type="number"
                                  :disabled="true"
                                  class="form-control"
                                  v-model="questionario.id"
                                  autofocus/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Título do Formulário:">
                  <b-input-group class="mb-6">
                    <b-form-input type="text"
                                  class="form-control"
                                  v-model="questionario.titulo"
                                  :disabled="true"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                    <b-form-group>
                        <b-form-group label="Situação:">
                            <b-form-select v-model="questionario.status" :disabled="true" id="checkbox-group-2" :options="situacoes"></b-form-select>
                        </b-form-group>
                    </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
      </b-modal>
      <b-modal title="Enviar E-mail" size="lg" ok-title="Salvar" cancel-title="Cancelar" v-model="modalEmail" @ok="modalConfirmaEmail()">
           <b-row>
           <b-col cols="6">
              <b-form-group label="Selecione qual campo de E-mail: " invalid-feedback='É obrigatório informar o formulário.'>
                    <b-form-select v-model.trim="pergunta_id_email" placeholder="" class="mb-6" :options='options_email'>
                  </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
      </b-modal>
      <b-modal title="Configurar CPF"  ok-title="Salvar" cancel-title="Cancelar" v-model="modalConfigCpf" @ok="confirmaConfigCpf()">
          <b-row>
           <b-col cols="6">
               <h6><b>Campo de Validação</b></h6>
            </b-col>
            <b-col cols="6">
              <h6><b>Campo de apresentação do formulário</b></h6>
            </b-col>
          </b-row>
          <b-row>
           <b-col cols="6">
               <span>CPF:</span>
            </b-col>
            <b-col cols="6">
              <b-form-group label="CPF: ">
                    <b-form-select v-model="cpf.pergunta_id_cpf" placeholder="" class="mb-6" :options='options_cpf'>
                  </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
           <b-col cols="6">
               <span>Nome:</span>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Nome: ">
                    <b-form-select v-model.trim="cpf.pergunta_id_nome" placeholder="" class="mb-6" :options='options_texto_livre'>
                  </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
           <b-col cols="6">
               <span>Data de Nascimento:</span>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Data de Nascimento: ">
                    <b-form-select v-model.trim="cpf.pergunta_id_data_nascimento" placeholder="" class="mb-6" :options='options_data'>
                  </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
           <b-col cols="6">
               <span>Nome da Mãe:</span>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Nome da Mãe: ">
                    <b-form-select v-model.trim="cpf.pergunta_id_nome_mae" placeholder="" class="mb-6" :options='options_texto_livre'>
                  </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
      </b-modal>
      <b-modal title="Configurar CNPJ"  ok-title="Salvar" cancel-title="Cancelar" v-model="modalConfigCnpj" @ok="confirmaConfigCnpj()">
           <b-row>
            <b-col cols="6">
               <h6><b>Campo de Validação</b></h6>
            </b-col>
            <b-col cols="6">
              <h6><b>Campo de apresentação do formulário</b></h6>
            </b-col>
          </b-row>
          <b-row>
           <b-col cols="6">
               <span>CNPJ:</span>
            </b-col>
            <b-col cols="6">
              <b-form-group label="CNPJ: ">
                    <b-form-select v-model.trim="cnpj.pergunta_id_cnpj" placeholder="" class="mb-6"  :options='options_cnpj'>
                  </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
           <b-col cols="6">
               <span>Razão Social:</span>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Razão Social: ">
                    <b-form-select v-model.trim="cnpj.pergunta_id_razao_social" placeholder="" class="mb-6" :options='options_texto_livre'>
                  </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
           <b-col cols="6">
               <span>Nome Fantasia:</span>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Nome Fantasia: ">
                    <b-form-select v-model.trim="cnpj.pergunta_id_nome_fantasia" placeholder="" class="mb-6" :options='options_texto_livre'>
                  </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
           <b-col cols="6">
               <span>Telefone:</span>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Telefone: ">
                    <b-form-select v-model.trim="cnpj.pergunta_id_telefone" placeholder="" class="mb-6" :options='options_telefone'>
                  </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
           <b-col cols="6">
               <span>Natureza Jurídica:</span>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Natureza Jurídica: ">
                    <b-form-select v-model.trim="cnpj.pergunta_id_natureza_juridica" placeholder="" class="mb-6" :options='options_texto_livre'>
                  </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
          <b-col cols="6">
               <span>Representante Legal:</span>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Representante Legal: ">
                    <b-form-select v-model.trim="cnpj.pergunta_id_representante_legal" placeholder="" class="mb-6" :options='options_texto_livre'>
                  </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="6">
               <span>Endereço:</span>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Endereço: ">
                    <b-form-select v-model.trim="cnpj.pergunta_id_endereco" placeholder="" class="mb-6" :options='options_texto_livre'>
                  </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
      </b-modal>
    </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import {eventType} from '@/components/shared/eventType'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'

miniToastr.init()

export default {
  components: {
    Pagination,
    Multiselect
  },
  created () {
    if (!this.can('questionario.index')) {
      this.$router.push('/')
    } else {
      this.$store.dispatch('getPerfis')
    }
  },
  data () {
    return {
      totalPorPagina: 10,
      resource: 'questionarios',
      modalControl: false,
      modalEmail: false,
      modalConfigCpf: false,
      modalConfigCnpj: false,
      modalTipo: '',
      titulo_descricao: '',
      idAlterar: '',
      titulo_botao: '',
      pergunta_id_email: null,
      id_formulario_selected: null,
      options_email: [{value: null, text: 'Selecione'}],  
      options_cpf: [{value: null, text: 'Selecione'}],  
      options_cnpj: [{value: null, text: 'Selecione'}],  
      options_texto_livre: [{value: null, text: 'Selecione'}],  
      options_data: [{value: null, text: 'Selecione'}], 
      options_telefone: [{value: null, text: 'Selecione'}], 
      situacoes: [
        { value: '', text: 'Selecione' },
        { value: 'AT', text: 'Ativo' },
        { value: 'IN', text: 'Inativo' },
        { value: 'PU', text: 'Publicado' },
        { value: 'SU', text: 'Suspenso' }
      ],
      cpf: [],
      cnpj: [],
      filtros: {
        filter: '',
        numCadastro: null,
        situacao: ''
      }
    }
  },
  computed: {
    perfilAtual () {
      return this.$store.state.questionario.perfilAtual
    },
    questionarios () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    perfis () {
      return this.$store.state.perfil.lista
    },
    questionario () {
      return this.$store.state.questionario.questionarioEditar
    }
  },
  watch: {
    'filtros.filter': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
    },
    'filtros.numCadastro': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
    },
    'filtros.areaResponsavel': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
    },
    'filtros.situacao': function () {
      this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    responder (id) {
      this.$router.push('/questionario/responder/' + id)
    },
    resetForm () {
      this.filtros.filter = null
      this.filtros.numCadastro = null
      this.filtros.situacao = ''
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    visualizarQuestionario (id) {
      this.$router.push('/formulario/visualizar/' + id)
    },
    visualizarEstruturaQuestionario (id) {
      this.$router.push('/formulario/visualizar/estrutura/' + id)
    },
    editarQuestionario (id) {
      this.$router.push('/formulario/editar/' + id)
    },
    duplicarQuestionario (id) {
      this.$router.push('/formulario/duplicar/' + id)
    },
    publicarQuestionario (id) {
      this.$router.push('/formulario/publicar/' + id)
    },
    suspenderPublicacao (id) {
      this.$router.push('/formulario/suspender/' + id)
    },
    visualizarRespostas (id) {
      this.$router.push('/formulario/respostas/' + id)
    },
    encaminharQuestionario (id) {
      this.$router.push('/formulario/encaminhar/' + id)
    },
    modal (id, tipo) {
      this.$store.dispatch('getQuestionario', id)
      this.idAlterar = id
      this.modalTipo = tipo
      this.titulo_descricao = tipo + ' Questionario'
      this.titulo_botao = tipo

      this.modalControl = true
    },
    modalConfirma () {
      if (this.modalTipo === 'Excluir') {
        this.excluirQuestionario(this.idAlterar)
      }

      if (this.modalTipo === 'Ativar') {
        this.ativarQuestionario(this.idAlterar)
      }

      if (this.modalTipo === 'Desativar') {
        this.inativarQuestionario(this.idAlterar)
      }

      this.idAlterar = ''
      this.modalTipo = ''
    },
    abrirModalEmail (id){
        this.id_formulario_selected = null
        this.options_email = [{value: null, text: 'Selecione'}]
        this.pergunta_id_email = null
        Vue.http.get('api/questionario/getPerguntasEmail/' + id).then(response => {
            if (response.body.success) {
               this.modalEmail = true
               this.id_formulario_selected = id
               let campo_email = response.body.data    
                if(campo_email.length <= 0){
                  miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
                  miniToastr.error('Nenhum campo de E-mail cadastrado para este formulário', 'Alerta!', 7000)
                  this.modalEmail = false
                }       
                for (let i = 0; i < campo_email.length; i++) {
                  let titulo = campo_email[i].titulo.replace(/<\/?[^>]+(>|$)/g, "")
                  this.options_email.push({value: campo_email[i].id, text: titulo})
                }
            }
        }).catch(erro => {
          if (!erro.body.success) {
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error('Erro ao buscar E-mail do formulário', 'Alerta!', 7000)
          }
        })
    },
    modalConfirmaEmail (){
      let data = {
        id: this.id_formulario_selected,
        pergunta_id_email: this.pergunta_id_email,
        envia_email: true
      }

      Vue.http.post('api/questionario/configurarEmail', data).then((response) => {
          if (response.body.success) {
            miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
            miniToastr.success(response.body.msg, 'Sucesso!', 7000)
            this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            this.modalEmail = false
          }
        })
        .catch((e) => {
          this.modalEmail = false
          console.log('Servidor está fora! ' + e)
        })

      this.loading = false
    },
    desativarEmail (id){
      this.$bvModal.msgBoxConfirm('Deseja desativar o envio de E-mail do formulário selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
            if (valor) {              
              let data = {
                id: id,
                pergunta_id_email: null,
                envia_email: false
              }
                      
            Vue.http.post('api/questionario/configurarEmail', data).then((response) => {
                if (response.body.success) {
                  miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                  miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                  this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
                  this.modalEmail = false
                }
              })
              .catch((e) => {
                this.modalEmail = false
                console.log('Servidor está fora! ' + e)
              })
            }
      }).catch(erro => {
        console.log(erro)
      })
    },
    desativarConfigCpf (id){
      this.$bvModal.msgBoxConfirm('Deseja desativar a configuração de CPF do formulário selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
          if (valor) {  
            Vue.http.post('api/questionario/desativarConfigCpf', {id: id}).then((response) => {
                if (response.body.success) {
                  miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                  miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                  this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
                  this.modalEmail = false
                }
              })
              .catch((e) => {
                this.modalEmail = false
                console.log('Servidor está fora! ' + e)
              })
            }
      }).catch(erro => {
        console.log(erro)
      })
    },
    desativarConfigCnpj (id){
      this.$bvModal.msgBoxConfirm('Deseja desativar a configuração de CNPJ do formulário selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
          if (valor) {             
            Vue.http.post('api/questionario/desativarConfigCnpj', {id: id}).then((response) => {
                if (response.body.success) {
                  miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                  miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                  this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
                  this.modalEmail = false
                }
              })
              .catch((e) => {
                this.modalEmail = false
                console.log('Servidor está fora! ' + e)
              })
            }
      }).catch(erro => {
        console.log(erro)
      })
    },
    abrirModalConfigCpf (id){    
        this.id_formulario_selected = null
        this.cpf = []
        Vue.http.get('api/questionario/getPerguntasConfigCpfCnpj/' + id).then(response => {
            if (response.body.success) {
               this.modalConfigCpf = true
               this.id_formulario_selected = id
               this.options_cpf = [{value: null, text: 'Selecione'}]
               this.options_texto_livre = [{value: null, text: 'Selecione'}]
               this.options_data = [{value: null, text: 'Selecione'}]
               let perguntas = response.body.data    
                if(perguntas.length <= 0){
                  miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
                  miniToastr.error('Nenhum campo de configuração cadastrado para este formulário', 'Alerta!', 7000)
                  this.modalConfigCpf = false
                }       
                this.cpf.pergunta_id_cpf = null
                this.cpf.pergunta_id_nome = null
                this.cpf.pergunta_id_nome_mae = null
                this.cpf.pergunta_id_data_nascimento = null

                if(perguntas.cpf){
                  var obj_cpf = perguntas.cpf
                  for (var prop in obj_cpf) {
                    this.options_cpf.push({value: obj_cpf[prop].value, text: obj_cpf[prop].text})
                  }               
                }

                if(perguntas.texto_livre){                 
                  var obj_texto = perguntas.texto_livre
                  for (var prop in obj_texto) {
                    this.options_texto_livre.push({value: obj_texto[prop].value, text: obj_texto[prop].text})
                  }              
                }

                if(perguntas.data){
                  var obj_data = perguntas.data
                  for (var prop in obj_data) {
                    this.options_data.push({value: obj_data[prop].value, text: obj_data[prop].text})
                  }                    
                }              
            }
        }).catch(erro => {
          if (!erro.body.success) {
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error('Erro ao buscar configurações do formulário', 'Alerta!', 7000)
          }
        })
    },
    abrirModalConfigCnpj (id){    
        this.id_formulario_selected = null
        this.cnpj = []
        Vue.http.get('api/questionario/getPerguntasConfigCpfCnpj/' + id).then(response => {
            if (response.body.success) {
              this.modalConfigCnpj = true
               this.id_formulario_selected = id
               this.options_cnpj = [{value: null, text: 'Selecione'}]
               this.options_texto_livre = [{value: null, text: 'Selecione'}]
               this.options_telefone = [{value: null, text: 'Selecione'}]

               let perguntas = response.body.data    
                if(perguntas.length <= 0){
                  miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
                  miniToastr.error('Nenhum campo de configuração cadastrado para este formulário', 'Alerta!', 7000)
                  this.modalConfigCnpj = false
                }       

                this.cnpj.pergunta_id_cnpj = null
                this.cnpj.pergunta_id_razao_social = null
                this.cnpj.pergunta_id_nome_fantasia = null
                this.cnpj.pergunta_id_telefone = null
                this.cnpj.pergunta_id_natureza_juridica = null
                this.cnpj.pergunta_id_representante_legal = null
                this.cnpj.pergunta_id_endereco = null
                
                if(perguntas.cnpj){
                  var obj_cnpj = perguntas.cnpj               
                  for (var prop in obj_cnpj) {
                    this.options_cnpj.push({value: obj_cnpj[prop].value, text: obj_cnpj[prop].text})
                  }    
                }

                if(perguntas.texto_livre){
                  var obj_texto_livre = perguntas.texto_livre
                  for (var prop in obj_texto_livre) {
                    this.options_texto_livre.push({value: obj_texto_livre[prop].value, text: obj_texto_livre[prop].text})
                  }
                }

                if(perguntas.telefone){
                  var obj_telefone = perguntas.telefone
                  for (var prop in obj_telefone) {
                    this.options_telefone.push({value: obj_telefone[prop].value, text: obj_telefone[prop].text})
                  }
                }

            }
        }).catch(erro => {
          if (!erro.body.success) {
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error('Erro ao buscar configurações do formulário', 'Alerta!', 7000)
          }
        })
    },
    confirmaConfigCpf (){  
      if(this.cpf.pergunta_id_cpf == null && 
          this.cpf.pergunta_id_data_nascimento == null && 
            this.cpf.pergunta_id_data_nome_mae == null && 
              this.cpf.pergunta_id_nome == null){
         miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
         miniToastr.error('Erro ao salvar configuração!', 'Alerta!', 7000)
      }

      let data = {
        questionario_id: this.id_formulario_selected,
        pergunta_id_cpf: this.cpf.pergunta_id_cpf,
        pergunta_id_nome: this.cpf.pergunta_id_nome,
        pergunta_id_data_nascimento: this.cpf.pergunta_id_data_nascimento,
        pergunta_id_nome_mae: this.cpf.pergunta_id_nome_mae,        
      }

      Vue.http.post('api/questionario/configurarCpf', data).then((response) => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
          this.modalEmail = false
        }
      })
      .catch((e) => {
        this.modalEmail = false
        console.log('Servidor está fora! ' + e)
      })
    },
    confirmaConfigCnpj (){  
      if(this.cnpj.pergunta_id_cnpj == null && 
          this.cnpj.pergunta_id_razao_social == null && 
            this.cnpj.pergunta_id_nome_fantasia == null && 
              this.cnpj.pergunta_id_telefone == null &&
                this.cnpj.pergunta_id_natureza_juridica == null &&
                  this.cnpj.pergunta_id_representante_legal == null){
         miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
         miniToastr.error('Erro ao salvar configuração!', 'Alerta!', 7000)
      }

      let data = {
        questionario_id: this.id_formulario_selected,
        pergunta_id_cnpj: this.cnpj.pergunta_id_cnpj,
        pergunta_id_razao_social: this.cnpj.pergunta_id_razao_social,
        pergunta_id_nome_fantasia: this.cnpj.pergunta_id_nome_fantasia,
        pergunta_id_telefone: this.cnpj.pergunta_id_telefone,
        pergunta_id_natureza_juridica: this.cnpj.pergunta_id_natureza_juridica,  
        pergunta_id_representante_legal: this.cnpj.pergunta_id_representante_legal, 
        pergunta_id_endereco: this.cnpj.pergunta_id_endereco,        
      }

      Vue.http.post('api/questionario/configurarCnpj', data).then((response) => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
          this.modalEmail = false
        }
      })
      .catch((e) => {
        this.modalEmail = false
        console.log('Servidor está fora! ' + e)
      })
    },
    excluirQuestionario (id) {
      this.$bvModal.msgBoxConfirm('Confirma a exlusão do registro selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.delete('api/questionario/' + this.questionario.id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          }).catch(erro => {
            if (!erro.body.success) {
              miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
              miniToastr.error(erro.body.msg, 'Alerta!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    inativarQuestionario (id) {
      this.$bvModal.msgBoxConfirm('Confirma a inativação do registro selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/questionario/inativar/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
        }
      })
    },
    ativarQuestionario (id) {
      this.$bvModal.msgBoxConfirm('Confirma a ativação do registro selecionado?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/questionario/ativar/' + id).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
        }
      })
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .multiselect.invalid .multiselect__tags,
    .multiselect.invalid .multiselect__tags span,
    .multiselect.invalid .multiselect__tags input {
        background:red;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/cliente/questionarios/Questionarios.vue